import React from 'react'

export default function FloatFormatter(props) {
  const {value} = props
  const isNotANumber = isNaN(parseFloat(value))
  const formatted = parseFloat(value).toFixed(2)
  return (
    <>{isNotANumber ? "0.00" : formatted }</>
  )
}
